import * as BASE from './base';

export function AdminSessionsList() {
    return BASE.POST('api/sessionsList', {});
}

export function AdminSessionDetails(sessionId) {
    return BASE.POST('api/sessionDetails', { sessionId });
}

export function AdminSessionsScan() {
    return BASE.POST('api/sessionsScan', {});
}

export function AdminChangeSessionStatus(sessionId) {
    return BASE.POST('api/changeSessionStatus', { sessionId });
}

